// extracted by mini-css-extract-plugin
export default {"Toaster":"Toaster29sH7yT1IQRM"};